module.exports = __webpack_public_path__ + "static/media/AmphanTri.61408e74.png";